import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GameDto } from "../../../models/game/dto/game.dto";

export const GAME_QUERY_KEY = (gameId: number) => ['game', gameId];

export const useGetGame = (gameId: number) => {
    const apiClient = useApiClient();

    return useQuery<GameDto>({
        queryKey: GAME_QUERY_KEY(gameId),
        queryFn: async () => {
            return apiClient.fetchApi<GameDto, {}>({
                method: 'GET',
                endpoint: `games/${gameId}/details`
            });
        },
        enabled: !!gameId,
    });
};